import { DetailItemCards } from "../../../detail-item-cards";
import { DetailSection } from "../../../detail-section";
import type { MotoresSectionViewModel } from "./types-motores-section";

export function MotoresSectionView({
  id,
  title,
  testId,
  cardsTestId,
  status,
  errorMessage,
  loadingMessage,
  emptyContent,
  onReauthenticate,
  onRetry,
  ultimaAtualizacao,
  cards,
}: MotoresSectionViewModel) {
  return (
    <DetailSection
      id={id}
      title={title}
      ultimaAtualizacao={ultimaAtualizacao}
      testId={testId}
      status={status}
      loadingMessage={loadingMessage}
      errorMessage={errorMessage}
      emptyContent={emptyContent}
      onReauthenticate={onReauthenticate}
      onRetry={onRetry}
    >
      <DetailItemCards testId={cardsTestId} cards={cards} />
    </DetailSection>
  );
}
